<h2 class="font-bold text-2xl mb-4">
  <tui-icon
    icon="@tui.settings"
    [style.border-width.rem]="0.25"></tui-icon>
  Обновление ПО
</h2>
<div>Закройте все вкладки с приложением для завершения обновления.</div>
